(() => {
  const allowedInterests = new Set(['all', 'sleeveless', 'shorts', 'tee']);
  function init(root = document) {
    root.querySelectorAll('[data-drop]').forEach(drop => {
      if (drop.dataset.ready) return;
      drop.dataset.ready = 'true';
      const controls = drop.querySelector('[data-filter-controls]');
      if (controls) controls.hidden = false;
      drop.querySelectorAll('[data-filter]').forEach(button => button.addEventListener('click', () => {
        const filter = button.dataset.filter;
        let visible = 0;
        drop.querySelectorAll('[data-category]').forEach(card => {
          card.hidden = filter !== 'all' && card.dataset.category !== filter;
          if (!card.hidden) visible++;
        });
        drop.querySelectorAll('[data-filter]').forEach(control => {
          const active = control === button;
          control.classList.toggle('is-active', active);
          control.setAttribute('aria-pressed', String(active));
        });
        drop.querySelector('[data-drop-count]').textContent = `${visible} ${visible === 1 ? 'PIECE' : 'PIECES'} / COMING SOON`;
      }));
    });
    root.querySelectorAll('[data-notify-interest]').forEach(select => {
      if (select.dataset.ready) return;
      select.dataset.ready = 'true';
      const update = () => {
        const interest = allowedInterests.has(select.value) ? select.value : 'all';
        select.form.querySelector('[data-notify-tags]').value = `newsletter,022-launch,022-interest-${interest}`;
      };
      select.addEventListener('change', update);
      select.form.addEventListener('submit', update);
      update();
    });
    root.querySelectorAll('[data-variant-select]').forEach(select => {
      if (select.dataset.ready) return;
      select.dataset.ready = 'true';
      select.addEventListener('change', () => {
        const option = select.selectedOptions[0];
        const section = select.closest('.product-details');
        section.querySelector('[data-product-price]').textContent = option.dataset.price;
        const button = section.querySelector('[data-add-button]');
        button.disabled = option.dataset.available !== 'true';
        button.textContent = button.disabled ? 'Sold out' : 'Add to bag';
      });
    });
  }
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-interest]');
    if (link && allowedInterests.has(link.dataset.interest)) {
      const select = document.querySelector('#notify [data-notify-interest]');
      if (select) {
        select.value = link.dataset.interest;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        document.querySelector('#notify input[type="email"]')?.focus({ preventScroll: true });
      }
    }
    document.querySelectorAll('[data-mobile-nav][open]').forEach(menu => {
      if (!menu.contains(event.target) || event.target.closest('a')) menu.open = false;
    });
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') document.querySelectorAll('[data-mobile-nav][open]').forEach(menu => {
      menu.open = false; menu.querySelector('summary').focus();
    });
  });
  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
